import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Redirect } from 'react-router-dom'
import images from '../../config/images'
import { RedirectText, Text } from './styles'
import { isSignUp } from '../../lib'

class Complete extends Component {
  constructor(props) {
    super(props)
    this.timer = 0
    this.state = {seconds: 5}
  }

  componentDidMount() {
    this.startTimer()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    if (isSignUp(this.props.location.pathname))
      this.props.recieveSignupstatus(false, this.props.user)
  }

  startTimer = () => {
    if (this.timer === 0) {
      this.timer = setInterval(this.countDown, 1000)
    }
  }

  countDown = () => {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1
    this.setState({seconds: seconds})

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer)
    }
  }

  render() {
    if (this.state.seconds === 0) {
      return (
        <Redirect
          to={'/'}
        />
      )
    }

    return (
      <div>
        <Text className="mb3 flex justify-center">
          {this.props.expired ? (
            <FormattedMessage id="signupComplete.expiredHeading"/>
          ) : this.props.activate ? (
            <FormattedMessage id="signupComplete.thanksActivate"/>
          ) : this.props.reset ? (
            <div>Reset successful</div>
          ) : this.props.changeEmail ? (
            <FormattedMessage id="signupComplete.successChangeEmail"/>
          ) : (
            ''
          )}
        </Text>
        <div className="mb3 flex justify-center items-center mb4">
          <img
            src={
              this.props.expired ? images.expired : images.signupCompleteIcon
            }
            alt="complete"
          />
        </div>
        <div className="tc mb4">
          <Text className="mb3">
            {!this.props.activate && !this.props.reset ? (
              <div>
                <FormattedMessage id="signupComplete.hi"/>
                {this.props.user},
              </div>
            ) : (
              ''
            )}
          </Text>
          {this.props.expired ? (
            <Text>
              <FormattedMessage id="signupComplete.expiredText"/>
            </Text>
          ) : this.props.activate ? (
            <Text>
              <FormattedMessage id="signupComplete.ActivationText"/>
            </Text>
          ) : this.props.reset ? (
            <Text>
              <FormattedMessage id="signupComplete.resetSuccessfullMessage"/>
            </Text>
          ) : this.props.changeEmail ? (
            <Text>
              <FormattedMessage id="signupComplete.changeEmailSuccessfullMessage"/>
            </Text>
          ) : (
            <div>
              <Text>
                <FormattedMessage id="signupComplete.thanks"/>
              </Text>
              <Text>
                <FormattedMessage id="signupComplete.activate"/>
              </Text>
            </div>
          )}
        </div>
        <div className="tc">
          <RedirectText>
            <FormattedMessage id="signupComplete.redirect"/>
            {this.state.seconds}...
          </RedirectText>
        </div>
      </div>
    )
  }
}

export default Complete



// WEBPACK FOOTER //
// ./src/components/SignupComplete/SignupComplete.js